import {
    IStep,
    IStepData,
    IPoint,
    Point,
    STEP_NAME_MAX_LENGTH,
    STEP_DESCRIPTION_MAX_LENGTH, IPointData
} from './index'
import {
    Criterion
} from '../../abstract'

export class Step extends Criterion<string> implements IStep {
    position: number
    points?: IPoint[]

    constructor(data?: IStepData) {
        super(data)
        this.position = data?.position || 0

        this.points = data?.points?.map(point => new Point(point))
    }

    validate(): boolean {
        return (this.validateName() && this.validateDescription() && this.validatePosition())
    }

    update(data?: IStepData): void {
        super.update(data);
        data?.points?.forEach((item: IPointData) => {
            this.points?.find((i: IPoint) => i.id === item.id)?.update(item);
        });
    }

    validateName(): boolean {
        let name = this.name
        return !!name && name.length <= STEP_NAME_MAX_LENGTH
    }

    validateDescription(): boolean {
        let desc = this.description
        return !desc || desc.length <= STEP_DESCRIPTION_MAX_LENGTH
    }

    validatePosition(): boolean {
        return this.position >= 0
    }
}